import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DailyManifest } from "./DailyManifest"
import { CustomDateField } from "../../../components/CustomDateField";
import { getLocation } from "../../../services/Location";
import moment from "moment";


export const Dashboard = () => {
    const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"));
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))
            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className={`w-full bg-white border rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>

                <div className="flex items-center justify-end">

                    <div className="flex items-center gap-2.5">

                        <div>
                            <select
                                value={locationId}
                                onChange={(e) => setLocationId(Number(e.target.value))}
                                className="w-[200px] border border-gray-300 rounded-md p-3 text-sm outline-none focus:border-primary bg-white"
                            >
                                <option value={0}>
                                    All
                                </option>
                                {locationOptions.map((loc: any, index: number) => (
                                    <option key={index} value={loc?.value}>
                                        {loc?.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <button className={`px-[8px] py-[6px] bg-primary rounded-lg border text-white text-nowrap flex items-center gap-1.5`}
                            onClick={() => {
                                navigate("/admin/services/addservice");
                            }}
                        >
                            <span className="material-symbols-outlined text-[25px] font-light">
                                add
                            </span>
                            <span className="text-xs font-medium">New Service</span>
                        </button>


                        <div className="flex items-center gap-1.5">
                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() - 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }>
                                    chevron_left
                                </span>
                            </button>


                            <CustomDateField
                                value={date}
                                onChange={(value) => { setDate(value) }}
                                className="w-[110px] border border-gray-300 rounded-xl px-[5px] py-[10px] text-sm outline-none focus:border-primary"
                                required={true}
                                showValidMessage={false}
                                isModified={true}
                            />




                            <button className={`px-[4px] py-[6px] rounded-lg border flex items-center justify-center`}>
                                <span className="material-symbols-outlined text-[25px] font-light"
                                    onClick={() =>
                                        setDate(() => {
                                            const d = new Date(date);
                                            d.setDate(d.getDate() + 1);
                                            return d.toISOString().split("T")[0];
                                        })
                                    }
                                >
                                    chevron_right
                                </span>
                            </button>
                        </div>


                    </div>
                </div>
                <div>

                    <DailyManifest date={date} locationId={locationId} />


                </div>
            </div>
        </div>
    )
}